import { Info } from 'luxon';


export const getLang = () => 'fr';


export const months = Info.months('long', { locale: getLang() });
